import {ContractAbi} from 'web3';

import {ContractAddress, Reward, TDeposit, TDepositForServer, TRewardForServer} from '../../../shared/api/contract';
import {ConnectorType} from '@reown/appkit';
import {MoonStaking} from '../../../shared/api/contract/ethers/moon-staking';
import i18n from "../../../i18n.ts";

type StatusWithdraw = 'ok' | 'error' | 'claim';

export class WithdrawDepositService extends MoonStaking {
    constructor(contractAddress: ContractAddress, abi: ContractAbi, provider: ConnectorType, walletAddress: ContractAddress) {
        super(contractAddress, abi, provider, walletAddress);
    }

    async withdraw(index: bigint, rewardsQuantity: number, maxIteration: number, setMsg: (msg: string) => void): Promise<StatusWithdraw> {
        try {
            if (rewardsQuantity <= maxIteration) return await this.withdrawAndClaim(index, setMsg);

            return 'claim';
        } catch (error) {
            console.log(error);

            return 'error';
        }
    }

    private async withdrawAndClaim(index: bigint, setMsg: (msg: string) => void): Promise<StatusWithdraw> {
        try {
            const gasEstimate = await this.contract.estimateGas.withdraw(index);
            setMsg(i18n.t('approve_withdraw'));

            const tx = await this.contract.withdraw(index, {
                gasLimit: gasEstimate.mul(110).div(100),
            });
            console.log(tx);

            setMsg(i18n.t('close_deposit'));
            const receipt = await tx.wait();
            console.log(receipt);
            return 'ok';
        } catch (error) {
            console.log(error);
            return 'error';
        }
    }

    async saveDeposit(deposits: TDepositForServer[]): Promise<void> {
        try {
            const response = await fetch(import.meta.env.VITE_DEPOSIT_API, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(deposits),
            });
        } catch (error) {
            console.log(error);
        }
    }

    formatIntToString(rewards: Reward[]): TRewardForServer[] {
        return [
            ...rewards.map(
                (reward): TRewardForServer => ({
                    amount: String(reward.amount),
                    imgUri: '',
                    symbol: reward.symbol,
                })
            ),
        ];
    }
}
